export default __webpack_public_path__ + "static/media/slot_jackpot.ca51b305.gif";